import Button from "components/Button/Button"
import { Modal } from "components/Modal"

export const DisputeEvidenceConfirmationModal = ({ isOpen, setIsOpen, onConfirm }: { isOpen: boolean, setIsOpen: (isOpen: boolean) => void, onConfirm: () => void }) => {
    return (
        <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} width="500px" height="170px">
            <div className="flex flex-col gap-2 self-start">
                <h2 className="font-medium text-xl text-base-foreground">Evidence Submission</h2>
                <div className="text-base-mutedForeground">Once submitted, no changes or additions can be made.</div>
                <div className="flex justify-end gap-2 mt-2">
                    <Button variant="outline" onClick={() => setIsOpen(false)}>Cancel</Button>
                    <Button variant="default" onClick={onConfirm}>Submit</Button>
                </div>
            </div>
        </Modal>
    )
}